export default "__VITE_ASSET__BJgFs9xZ__"